import { gsap } from "gsap";

export default class SectionModule {
    constructor(dom) {
        this.dom = dom;
        
        this.id = this.dom.id;

        switch (this.id) {
            case "page_brand_list":
            case "page_education_list":
                this.calculateHeight();
                this.handleBrandList();
                break;

        }

        window.addEventListener("resize", () => this.resize());
    }

    calculateHeight() {
        const limitedContents = this.dom.querySelectorAll(".limited");
        limitedContents.forEach((limited) => {
            // get limited content offset top and height
            const offsetTop = limited.parentNode.offsetTop;
            const height = limited.offsetHeight;

            // set close height var to limited content offset top + height
            const contentWrap = limited.closest(".content-wrap");
            // set contentWrap style var --closeHeight to limited content offset top + height
            contentWrap.style.setProperty("--closeHeight", `${offsetTop + height}px`);

            // if listItem is not active
            const listItem = limited.closest(".list-item");
            if (!listItem.classList.contains("active")) {
                gsap.set(contentWrap, {
                    height: offsetTop + height
                });
            }
        });
    }

    handleBrandList() {
        const toggleBtns = this.dom.querySelectorAll(".toggle-btn");

        toggleBtns.forEach((btn) => {
            btn.addEventListener("click", () => {
                // closet class .list-item add class active
                const listItem = btn.closest(".list-item");
                listItem.classList.toggle("active");

                // toggle content height, using gsap to animate height from 0 to auto
                const contentWrap = listItem.querySelector(".content-wrap");
                if (listItem.classList.contains("active")) {
                    gsap.to(contentWrap, {
                        height: "auto",
                        duration: 0.5,
                        ease: "power2.out",
                    });
                } else {
                    gsap.to(contentWrap, {
                        height: contentWrap.style.getPropertyValue("--closeHeight"),
                        duration: 0.5,
                        ease: "power2.in",
                    });
                }
            });
        });
    }

    resize() {
        this.calculateHeight();
    }
}
